/**
 * Overview Counts slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';

export interface OverviewCounts {
  users: {
    total: number;
  };
  programs: {
    total: number;
    active: number;
    inactive: number;
  };
  resources: {
    total: number;
    active: number;
    inactive: number;
  };
  modules: {
    total: number;
    active: number;
    inactive: number;
  };
  microPractices: {
    total: number;
    active: number;
    inactive: number;
  };
}

const initialState = {
  overviewCounts: null as OverviewCounts | null,
  loading: false,
  error: null as string | null,
};

const overviewCountsSlice = createSlice({
  name: 'overviewCounts',
  initialState,
  reducers: {
    setOverviewCounts(state, action) {
      state.overviewCounts = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const overviewCountsReducer = overviewCountsSlice.reducer;

// Actions
export const {
  setOverviewCounts,
  setLoading,
  setError,
  clearError,
} = overviewCountsSlice.actions;

// Async Actions
export const fetchOverviewCounts = createAction('OVERVIEW_COUNTS/FETCH_COUNTS');

